var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"tw-text-base lg:tw-text-xl tw-text-grey-800 tw-mb-1"},[_vm._t("headline")],2),(_vm.$slots.subline)?_c('p',[_vm._t("subline")],2):_vm._e(),_vm._t("form")],2)}
var staticRenderFns = []

export { render, staticRenderFns }